import { LOAD_CUSTOMER_PERMISSIONS } from 'actions/actionTypes';
import { queryCustomerPermissions } from 'api/customerPermissionsQuery';
import {
  queryCustomerPermissionsSuccess,
  queryCustomerPermissionsFailure
} from 'actions';
import { apiPromise } from './apiPromise';

export const customerPermissions = store => next => (action) => {
  switch (action.type) {
    case LOAD_CUSTOMER_PERMISSIONS.REQUEST:
    {
      next(action);
      return apiPromise(
        store,
        action,
        queryCustomerPermissions,
        [],
        queryCustomerPermissionsSuccess,
        queryCustomerPermissionsFailure
      );
    }
    default:
      next(action);
      return Promise.resolve();
  }
};
